import React, { useCallback } from 'react'
import { Box, Button, Divider } from '@mui/material'
import { Check as CheckIcon, Clear as ClearIcon } from '@mui/icons-material'
import { useDispatch, useSelector } from 'react-redux'
import Icon from '@mui/material/Icon'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useStyles } from './SlidesStyles'
import { sendSlidesByCaseId, getDispatchData } from '../../actions'
import { RootState } from '../../reducers'
import CircularProgress from '@mui/material/CircularProgress'
import { SlideHandlingBase } from './SlideHandlingBase'

export function SendSlides({ userId, setUserInfo }) {
  const dispatch = useDispatch()
  const { re_slide_success, re_slide_error } = useSelector((state: RootState) => state.sendSlidesDataResponse)
  const filterData = useSelector((state: RootState) => state.filterPayloadResponse)
  const message = useSelector((state: RootState) => state.errorMessage)
  const { data } = useSelector((state: RootState) => state.getDispatchData)

  const handleErrorMessage = useCallback(() => {
    switch (message) {
      case 'ERROR_DATA_VALIDATION_1':
        return 'The case number is not recognized'
      case 'ERROR_DATA_VALIDATION_2':
        return 'Case is not in valid stage to receive/dispatch slides'
      case 'ERROR_DATA_VALIDATION_3':
        return "The case doesn't belong to the Pathologist"
      default:
        return 'The case is not Valid'
    }
  }, [message])

  const updateDataTable = useCallback(async () => {
    await dispatch(getDispatchData(filterData))
    setUserInfo(null)
  }, [dispatch, filterData, setUserInfo])

  const handleSubmit = useCallback(
    async (val, scannerMode) => {
      await dispatch(sendSlidesByCaseId({ id: userId, payload: val }))

      if (scannerMode) {
        // For scanner mode, delay update to allow viewing success message
        setTimeout(() => {
          updateDataTable()
        }, 1500)
      } else if (re_slide_success !== false && re_slide_error !== true) {
        updateDataTable()
      }
    },
    [dispatch, userId, re_slide_success, re_slide_error, updateDataTable],
  )

  const successMessage = useCallback((caseId) => {
    return `Scanning ${caseId} is successful. You may scan another value or click close to exit.`
  }, [])

  return (
    <SlideHandlingBase
      userId={userId}
      title="Send Slides"
      buttonText="Send Slides"
      dialogTitle="Distribute Slides"
      dialogPrompt="Scan Barcode now, or enter the TRF ID of the slides you wish to distribute:"
      buttonIcon="send"
      inputLabel="Barcode TRF ID (5 characters only)"
      maxCaseIdLength={5}
      onSubmit={handleSubmit}
      successMessage={successMessage}
      errorMessage={re_slide_error ? handleErrorMessage() : undefined}
      isSuccess={re_slide_success}
      isError={re_slide_error}
      buttonClassName="sendSlidesButton"
    />
  )
}
